import { SHOW_MODAL, HIDE_MODAL } from "./types";

export function showModal(modal, modalContent) {
  return {
    type: SHOW_MODAL,
    modal,
    modalContent,
  };
}

export function hideModal(modal) {
  return {
    type: HIDE_MODAL,
    modal,
  };
}



// WEBPACK FOOTER //
// ./src/actions/modalActions.js